import React, { createContext, useContext } from 'react';
export const TestableContext = /*#__PURE__*/createContext([]);
export const TestableProvider = ({
  children,
  testId
}) => {
  const idPath = useContext(TestableContext);
  return /*#__PURE__*/React.createElement(TestableContext.Provider, {
    value: [...idPath, testId]
  }, children);
};